<template>
    <div class="grin-container">
        <g-level vertical-align="top">
            <g-level-item>
                <div>
                    <g-typography tag="div" color="info">
                        STEP {{ currentStep }} OF {{ totalSteps }}
                    </g-typography>
                    <g-typography v-if="title && !isLoading" tag="h1" font-weight="semibold">
                        {{ title }}
                    </g-typography>
                </div>
            </g-level-item>
            <template slot="right">
                <g-button shape="circle" icon="times" theme="live" size="large" @click="attemptExit" />
            </template>
        </g-level>
        <global-exit-modal
            :visible="exitModal"
            @global-modal-exit="continueToExit"
            @global-modal-cancel="preventExit"
        />
    </div>
</template>

<script>
    import GlobalExitModal from './GlobalExitModal';
    import GlobalExitModalMixin from '../mixins/GlobalExitModalMixin';
    import ProposalProgressMixin from '../mixins/ProposalProgressMixin';

    export default {
        name:       'ProposalStepHeader',
        components: {
            GlobalExitModal,
        },
        mixins: [
            GlobalExitModalMixin,
            ProposalProgressMixin,
        ],
        props: {
            title: {
                type: String,
            },
            isLoading: {
                type:    Boolean,
                default: false,
            },
        },
        methods: {
            continueToExit() {
                this.$router.push({name: 'v2.campaign.proposal'});
            },
        },
    };
</script>

<style lang="scss" scoped>
    .grin-container {
        background-color: $g-color-grey-3;
        padding: $g-spacing-6;
    }
</style>
